export const QA_NAME_DOC_FLOW_EPOST_VALIDATION_ERRORS_REPORT_BUTTON =
  'docFlowEpostValidationErrorsReportButton'
